import { z } from "zod";

export const SponsorSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  email: z.union([
    z.string().email({ message: "Invalid email address" }),
    z.literal("")
  ]).optional(),  website: z.string().url({ message: "Invalid website URL" }),
  description: z.string().min(1, { message: "Description is required" }),
  isPriority: z.boolean().default(false),
  rank: z.number().int().min(0).default(0),
});
